"use client";

import { FallbackImage } from "@/components/fallback-image";
import { Link } from "@/components/link";
import { buildImageSrcSet, withImageRenderParams } from "@garimpa/lib/imageUrls";

interface SimilarArtistCardProps {
  id: string;
  imageUrl: string;
  name: string;
}

export function SimilarArtistCard({ id, imageUrl, name }: SimilarArtistCardProps) {
  return (
    <Link to={`/artist/${id}`} className="flex flex-col items-center gap-2 flex-shrink-0 group">
      <div className="w-24 h-24 rounded-full overflow-hidden bg-secondary transition-transform group-hover:scale-105">
        <FallbackImage
          src={withImageRenderParams(imageUrl, { width: 150 })}
          srcSet={buildImageSrcSet(imageUrl, [150, 320])}
          alt=""
          fallback="person"
          className="rounded-full"
          sizes="96px"
        />
      </div>
      <span className="text-sm text-center max-w-[96px] truncate text-muted-foreground group-hover:text-foreground transition-colors">
        {name}
      </span>
    </Link>
  );
}
